import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import Login from '@/pages/Login';
import MechanicDashboard from '@/pages/MechanicDashboard';
import AdminDashboard from '@/pages/AdminDashboard';
import MechanicManagement from '@/pages/MechanicManagement';
import { Toaster } from '@/components/ui/sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      fetch(`${API}/auth/me`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(res => res.json())
      .then(data => {
        if (data.id) {
          setUser(data);
        } else {
          localStorage.removeItem('token');
        }
      })
      .catch(() => {
        localStorage.removeItem('token');
      })
      .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <div className="text-red-600 text-xl">Cargando...</div>
      </div>
    );
  }

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={
            user ? <Navigate to={user.rol === 'ADMIN' ? '/admin/dashboard' : '/mechanic/dashboard'} /> : <Login setUser={setUser} />
          } />
          <Route path="/mechanic/dashboard" element={
            user && user.rol === 'MECANICO' ? <MechanicDashboard user={user} setUser={setUser} /> : <Navigate to="/login" />
          } />
          <Route path="/admin/dashboard" element={
            user && user.rol === 'ADMIN' ? <AdminDashboard user={user} setUser={setUser} /> : <Navigate to="/login" />
          } />
          <Route path="/admin/mechanics" element={
            user && user.rol === 'ADMIN' ? <MechanicManagement user={user} setUser={setUser} /> : <Navigate to="/login" />
          } />
          <Route path="/" element={
            <Navigate to={user ? (user.rol === 'ADMIN' ? '/admin/dashboard' : '/mechanic/dashboard') : '/login'} />
          } />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </>
  );
}

export default App;
